import React, { useState, useEffect } from "react";
import {
  Flex,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Button,
  SimpleGrid,
  Stack,
  FormErrorMessage,
  Text,
  RadioGroup,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Checkbox,
} from "@chakra-ui/react";
import { Formik, Form, FieldArray, Field } from "formik";
import ReactSelect from "react-select";
import Creatable from "react-select/creatable";
import axios from "axios";
import locations from "variables/locations";
import Card from "components/Card/Card";
import apiUrl from "variables/api";
import darkStyles from "variables/darkStyles";
import { FaSearch, FaPlus, FaTrash } from "react-icons/fa";
import CustomCheckbox from "components/Checkbox/CustomCheckbox";
import SignatureCanvas from "react-signature-canvas";

const initialValues = {
  receivingUnit: "",
  dateTime: "",
  location: "",
  placeDescription: "",
  urgencyCode: "",
  interview: "",
  departureType: "",
  teamType: "",
  teamMembers: [{
    user: "",
    role: "",
    isLeader: false,
  }],
  assistanceProvided: "",
  deathOccurred: "",
  deathTime: "",
  crimeSuspected: "",
  notified: "",
  deathCardIssued: "",
  medicalCardIssued: "",
  signature: "",
  additionalAssistance: [],
  transportDestination: "",
  refusalReason: "",
  refusalDateTime: "",
};

const validate = (values) => {
  const errors = {};
  // Dodaj walidację dla każdego pola
  if (!values.receivingUnit) {
    errors.receivingUnit = "To pole jest obowiazkowe";
  }
  if (!values.dateTime) {
    errors.dateTime = "To pole jest obowiazkowe";
  }
  if (!values.location) {
    errors.location = "To pole jest obowiazkowe";
  }
  if (!values.placeDescription) {
    errors.placeDescription = "To pole jest obowiazkowe";
  }
  if (!values.urgencyCode) {
    errors.urgencyCode = "To pole jest obowiazkowe";
  }
  if (!values.interview) {
    errors.interview = "To pole jest obowiazkowe";
  }
  if (!values.departureType) {
    errors.departureType = "To pole jest obowiazkowe";
  }
  if (!values.teamType) {
    errors.teamType = "To pole jest obowiazkowe";
  }
  if (!values.teamMembers.length) {
    errors.teamMembers = "To pole jest obowiazkowe";
  }
  if (!values.assistanceProvided) {
    errors.assistanceProvided = "To pole jest obowiazkowe";
  }
  if (!values.deathOccurred) {
    errors.deathOccurred = "To pole jest obowiazkowe";
  }
  if (!values.deathTime) {
    errors.deathTime = "To pole jest obowiazkowe";
  }
  if (!values.crimeSuspected) {
    errors.crimeSuspected = "To pole jest obowiazkowe";
  }
  if (!values.notified) {
    errors.notified = "To pole jest obowiazkowe";
  }
  if (!values.deathCardIssued) {
    errors.deathCardIssued = "To pole jest obowiazkowe";
  }
  if (!values.medicalCardIssued) {
    errors.medicalCardIssued = "To pole jest obowiazkowe";
  }
  if (!values.signature) {
    errors.signature = "To pole jest obowiazkowe";
  }
  return errors;
};

const KZWForm = () => {
  const [formData, setFormData] = useState(initialValues);

  const [peoples, setPeoples] = useState([]);
  useEffect(() => {
    axios
      .get(apiUrl + "/data/peoples", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        console.log(response.data);
        response.data.push({ value: "WSP", label: "WSP" });
        setPeoples(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    console.log("Dane formularza", values);
    setFormData(values);
    
  };

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Card minH="125px">
        <Flex direction="column">
          <Formik
            initialValues={initialValues}
            validate={validate}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <Flex direction="column" gap="3">
                  <Text fontSize="xl" font={"bold"}>
                    I - Przyjęcie wezwania
                  </Text>
                  <SimpleGrid columns={{ sm: 1, md: 2, xl: 4 }} spacing="10px 24px">
                    <Field name="receivingUnit">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors[field.name] && form.touched[field.name]
                          }
                        >
                          <FormLabel fontWeight={"bold"}>
                            Jednostka przyjmująca zgłoszenie
                          </FormLabel>
                          <RadioGroup {...field} colorScheme="red">
                            <Stack direction="row">
                              <CustomCheckbox
                                key="401[SA]59"
                                label="401[SA]59"
                                isChecked={
                                  form.values[field.name] === "401[SA]59"
                                }
                                onChange={() => {
                                  form.setFieldValue(field.name, "401[SA]59");
                                }}
                              />
                              <CustomCheckbox
                                key="Ratownik 5"
                                label="Ratownik 5"
                                isChecked={
                                  form.values[field.name] === "Ratownik 5"
                                }
                                onChange={() => {
                                  form.setFieldValue(field.name, "Ratownik 5");
                                }}
                              />
                            </Stack>
                          </RadioGroup>
                          <FormErrorMessage>
                            {form.errors[field.name]}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Field name="dispatchNumber">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors[field.name] && form.touched[field.name]
                          }
                        >
                          <FormLabel fontWeight={"bold"}>Numer zlecenia wyjazdu</FormLabel>
                          <Flex gap={3}>
                            <Input
                              type="text"
                              {...field}
                              disabled
                              placeholder={"Wyszukaj..."}
                            />
                            <Button>
                              <FaSearch />
                            </Button>
                          </Flex>
                          <FormErrorMessage>
                            {form.errors[field.name]}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Field name="dateTime">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors.dateTime && form.touched.dateTime
                          }
                        >
                          <FormLabel fontWeight={"bold"}>
                            Data i godzina przyjęcia wezwania
                          </FormLabel>
                          <Input type="datetime-local" {...field} />
                          <FormErrorMessage>
                            {form.errors.dateTime}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Field name="location">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors[field.name] && form.touched[field.name]
                          }
                        >
                          <FormLabel fontWeight={"bold"}>Lokalizacja</FormLabel>
                          <ReactSelect
                            {...field}
                            options={locations}
                            placeholder="Wybierz..."
                            styles={darkStyles()}
                            isLoading={!locations.length}
                            onChange={(selectedOption) =>
                              form.setFieldValue(field.name, selectedOption)
                            }
                          />
                          <FormErrorMessage>
                            {form.errors[field.name]}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Field name="placeDescription">
                      {({ field, form }) => (
                        <FormControl
                          gridColumn={{base: "span 1", md: "span 2", xl: "span 4"}}
                          isInvalid={
                            form.errors.placeDescription &&
                            form.touched.placeDescription
                          }
                        >
                          <FormLabel fontWeight={"bold"}>Opis miejsca zdarzenia</FormLabel>
                          <Textarea
                            {...field}
                            placeholder="Opis miejsca zdarzenia"
                          />
                          <FormErrorMessage>
                            {form.errors.placeDescription}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Field name="urgencyCode">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors.urgencyCode && form.touched.urgencyCode
                          }
                        >
                          <FormLabel fontWeight={"bold"}>Kod pilności</FormLabel>
                          <ReactSelect
                            {...field}
                            options={[
                              { label: "Kod: 1 (Alarmowo)", value: 1 },
                              { label: "Kod: 2 (Pilny)", value: 2 },
                              { label: "Kod: 3 (Inny)", value: 3 },
                            ]}
                            placeholder="Wybierz..."
                            styles={darkStyles()}
                            onChange={(selectedOption) => {
                              form.setFieldValue(field.name, selectedOption);
                              form.setFieldValue(
                                "departureType",
                                selectedOption.value === 1
                                  ? { label: "na sygnale", value: "alarmowy" }
                                  : selectedOption.value == 2
                                  ? { label: "zwykly", value: "zwykly" }
                                  : null
                              );
                            }}
                          />
                          <FormErrorMessage>
                            {form.errors.urgencyCode}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Field name="patientName">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors.patientName && form.touched.patientName
                          }
                        >
                          <FormLabel fontWeight={"bold"}>Nazwisko i imię pacjenta</FormLabel>
                          <Input
                            type="text"
                            {...field}
                            placeholder="Nazwisko i imię pacjenta"
                          />
                          <FormErrorMessage>
                            {form.errors.patientName}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Field name="ageGroup">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors.ageGroup && form.touched.ageGroup
                          }
                        >
                          <FormLabel fontWeight={"bold"}>Określenie wieku</FormLabel>
                          <RadioGroup {...field} colorScheme="red">
                            <Stack direction="row">
                              <CustomCheckbox
                                key="dziecko"
                                label="Dziecko"
                                isChecked={form.values.ageGroup === "dziecko"}
                                onChange={() => {
                                  form.setFieldValue(field.name, "dziecko");
                                }}
                              />
                              <CustomCheckbox
                                key="dorosly"
                                label="Dorosły"
                                isChecked={form.values.ageGroup === "dorosly"}
                                onChange={() => {
                                  form.setFieldValue(field.name, "dorosly");
                                }}
                              />
                            </Stack>
                          </RadioGroup>
                          <FormErrorMessage>
                            {form.errors.ageGroup}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Field name="gender">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={form.errors.gender && form.touched.gender}
                        >
                          <FormLabel fontWeight={"bold"}>Płeć</FormLabel>
                          <RadioGroup {...field} colorScheme="red">
                            <Stack direction="row">
                              <CustomCheckbox
                                key="K"
                                label="K"
                                isChecked={form.values[field.name] === "K"}
                                onChange={() => {
                                  form.setFieldValue(field.name, "K");
                                }}
                              />
                              <CustomCheckbox
                                key="M"
                                label="M"
                                isChecked={form.values[field.name] === "M"}
                                onChange={() => {
                                  form.setFieldValue(field.name, "M");
                                }}
                              />
                            </Stack>
                          </RadioGroup>
                          <FormErrorMessage>
                            {form.errors.gender}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Field name="interview">
                      {({ field, form }) => (
                        <FormControl
                        gridColumn={{base: "span 1", md: "span 2", xl: "span 4"}}
                          isInvalid={
                            form.errors.interview && form.touched.interview
                          }
                        >
                          <FormLabel fontWeight={"bold"}>Wywiad</FormLabel>
                          <Textarea {...field} placeholder="Wywiad" />
                          <FormErrorMessage>
                            {form.errors.interview}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                  </SimpleGrid>
                  <Text fontSize="xl">II - Podjęcie decyzji</Text>
                  <SimpleGrid columns={{ sm: 1, md: 4 }} spacing="24px">
                    <Field name="departureType">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors.departureType &&
                            form.touched.departureType
                          }
                        >
                          <FormLabel fontWeight={"bold"}>Rodzaj wyjazdu</FormLabel>
                          <ReactSelect
                            {...field}
                            options={[
                              { label: "na sygnale", value: "alarmowy" },
                              { label: "zwykly", value: "zwykly" },
                            ]}
                            placeholder="Wybierz..."
                            styles={darkStyles()}
                            isDisabled={form.values.urgencyCode.value !== 3}
                            onChange={(selectedOption) =>
                              form.setFieldValue(field.name, selectedOption)
                            }
                          />
                          <FormErrorMessage>
                            {form.errors.departureType}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Field name="teamType">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors.teamType && form.touched.teamType
                          }
                        >
                          <FormLabel fontWeight={"bold"}>Typ zespołu</FormLabel>
                          <RadioGroup {...field} colorScheme="red">
                            <Stack direction="row">
                              <CustomCheckbox
                                key="podstawowy"
                                label="Podstawowy"
                                isChecked={
                                  form.values.teamType === "podstawowy"
                                }
                                onChange={() => {
                                  form.setFieldValue(field.name, "podstawowy");
                                }}
                              />
                              <CustomCheckbox
                                key="specjalistyczny"
                                label="Specjalistyczny"
                                isChecked={
                                  form.values.teamType === "specjalistyczny"
                                }
                                onChange={() => {
                                  form.setFieldValue(
                                    field.name,
                                    "specjalistyczny"
                                  );
                                }}
                              />
                            </Stack>
                          </RadioGroup>
                          <FormErrorMessage>
                            {form.errors.teamType}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Field name="teamMembers">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors.teamMembers && form.touched.teamMembers
                          }
                          gridColumn={{base: "span 1", md: "span 2", xl: "span 4"}}
                        >
                          <FormLabel fontWeight={"bold"}>Skład ZRM</FormLabel>
                          <FieldArray name="teamMembers">
                            {({ push, remove }) => (
                              <>
                                <TableContainer>
                                  <Table>
                                    <Thead>
                                      <Tr>
                                        <Th>Nick</Th>
                                        <Th>Zawód</Th>
                                        <Th isNumeric>Czy kierownik</Th>
                                        <Th isNumeric>
                                          <Button
                                            leftIcon={<FaPlus />}
                                            disabled={
                                              form.values.teamMembers.length >=
                                              4
                                            }
                                            colorScheme="green"
                                            onClick={() => {
                                              if (
                                                form.values.teamMembers
                                                  .length >= 4
                                              )
                                                return;
                                              push({
                                                user: "",
                                                role: "",
                                                isLeader: false,
                                              });
                                            }}
                                          >
                                            {form.values.teamMembers.length} / 4
                                          </Button>
                                        </Th>
                                      </Tr>
                                    </Thead>
                                    <Tbody>
                                      {form.values.teamMembers.map(
                                        (member, index) => (
                                          <Tr key={index}>
                                            <Td>
                                              <Field
                                                name={`teamMembers.${index}.user`}
                                              >
                                                {({ field }) => (
                                                  <ReactSelect
                                                    {...field}
                                                    options={peoples}
                                                    placeholder="Wybierz..."
                                                    styles={darkStyles()}
                                                    menuPosition="fixed"
                                                    onChange={(
                                                      selectedOption
                                                    ) =>
                                                      form.setFieldValue(
                                                        `teamMembers.${index}.user`,
                                                        selectedOption
                                                      )
                                                    }
                                                  />
                                                )}
                                              </Field>
                                            </Td>
                                            <Td>
                                              <Field
                                                name={`teamMembers.${index}.role`}
                                              >
                                                {({ field }) => (
                                                  <ReactSelect
                                                    {...field}
                                                    options={[
                                                      {
                                                        label: "Ratownik",
                                                        value: "Ratownik",
                                                      },
                                                      {
                                                        label:
                                                          "Pielegniarka/pielegniarz",
                                                        value:
                                                          "Pielegniarka/pielegniarz",
                                                      },
                                                      {
                                                        label: "Lekarz",
                                                        value: "Lekarz",
                                                      },
                                                      {
                                                        label: "Pilot",
                                                        value: "Pilot",
                                                      },
                                                    ]}
                                                    menuPosition="fixed"
                                                    placeholder="Wybierz..."
                                                    styles={darkStyles()}
                                                    onChange={(option) =>
                                                      form.setFieldValue(
                                                        `teamMembers.${index}.role`,
                                                        option
                                                      )
                                                    }
                                                  />
                                                )}
                                              </Field>
                                            </Td>
                                            <Td isNumeric>
                                              <Field
                                                name={`teamMembers.${index}.isLeader`}
                                              >
                                                {({ field }) => (
                                                  <Checkbox
                                                    {...field}
                                                    isChecked={field.value}
                                                    onChange={(e) => {
                                                      const isChecked =
                                                        e.target.checked;
                                                      form.setFieldValue(
                                                        `teamMembers.${index}.isLeader`,
                                                        isChecked
                                                      );
                                                      if (isChecked) {
                                                        form.values.teamMembers.forEach(
                                                          (member, idx) => {
                                                            if (idx !== index) {
                                                              form.setFieldValue(
                                                                `teamMembers.${idx}.isLeader`,
                                                                false
                                                              );
                                                            }
                                                          }
                                                        );
                                                      }
                                                    }}
                                                  />
                                                )}
                                              </Field>
                                            </Td>
                                            <Td isNumeric>
                                              <Button
                                                onClick={() => remove(index)}
                                                colorScheme="red"
                                              >
                                                <FaTrash />
                                              </Button>
                                            </Td>
                                          </Tr>
                                        )
                                      )}
                                    </Tbody>
                                  </Table>
                                </TableContainer>
                                <FormErrorMessage>
                                  {form.errors.teamMembers}
                                </FormErrorMessage>
                              </>
                            )}
                          </FieldArray>
                        </FormControl>
                      )}
                    </Field>
                  </SimpleGrid>
                  <Text fontSize="xl">III - Realizacja zlecenia</Text>
                  <SimpleGrid columns={{ sm: 1, md: 4 }} spacing="24px">
                    <Field name="assistanceProvided">
                      {({ field, form }) => (
                        <FormControl
                        gridColumn={{base: "span 1", md: "span 2", xl: "span 4"}}
                          isInvalid={
                            form.errors.assistanceProvided &&
                            form.touched.assistanceProvided
                          }
                        >
                          <FormLabel fontWeight={"bold"}>
                            Udzielono pomocy
                          </FormLabel>
                          <Flex direction={{base: 'column', md: 'column', xl: 'row'}} gap={5}>
                            <RadioGroup {...field} colorScheme="red">
                              <Stack direction="row">
                                <CustomCheckbox
                                  key="W rejonie operacyjnym"
                                  label="W rejonie operacyjnym"
                                  isChecked={
                                    form.values.assistanceProvided ===
                                    "W rejonie operacyjnym"
                                  }
                                  onChange={() => {
                                    form.setFieldValue(
                                      field.name,
                                      "W rejonie operacyjnym"
                                    );
                                  }}
                                />
                                <CustomCheckbox
                                  key="Poza rejonem operacyjnym"
                                  label="Poza rejonem operacyjnym"
                                  isChecked={
                                    form.values.assistanceProvided ===
                                    "Poza rejonem operacyjnym"
                                  }
                                  onChange={() => {
                                    form.setFieldValue(
                                      field.name,
                                      "Poza rejonem operacyjnym"
                                    );
                                  }}
                                />
                              </Stack>
                            </RadioGroup>
                            <Flex direction={"column"}>
                              <CustomCheckbox
                                key="Pacjent pozostał na miejscu zdarzenia"
                                label="Pacjent pozostał na miejscu zdarzenia"
                                isChecked={form.values.additionalAssistance.includes(
                                  "Pacjent pozostał na miejscu zdarzenia"
                                )}
                                onChange={() => {
                                  const newValue = form.values.additionalAssistance.includes(
                                    "Pacjent pozostał na miejscu zdarzenia"
                                  )
                                    ? form.values.additionalAssistance.filter(
                                        (item) =>
                                          item !==
                                          "Pacjent pozostał na miejscu zdarzenia"
                                      )
                                    : [
                                        ...form.values.additionalAssistance,
                                        "Pacjent pozostał na miejscu zdarzenia",
                                      ];
                                  form.setFieldValue(
                                    "additionalAssistance",
                                    newValue
                                  );
                                }}
                              />
                              <CustomCheckbox
                                key="Udzielono pomocy i przewieziono do:"
                                label="Udzielono pomocy i przewieziono do:"
                                isChecked={form.values.additionalAssistance.includes(
                                  "Udzielono pomocy i przewieziono do:"
                                )}
                                onChange={() => {
                                  const newValue = form.values.additionalAssistance.includes(
                                    "Udzielono pomocy i przewieziono do:"
                                  )
                                    ? form.values.additionalAssistance.filter(
                                        (item) =>
                                          item !==
                                          "Udzielono pomocy i przewieziono do:"
                                      )
                                    : [
                                        ...form.values.additionalAssistance,
                                        "Udzielono pomocy i przewieziono do:",
                                      ];
                                  form.setFieldValue(
                                    "additionalAssistance",
                                    newValue
                                  );
                                }}
                              />

                              <CustomCheckbox
                                key="Przekazano LPR"
                                label="Przekazano LPR"
                                isChecked={form.values.additionalAssistance.includes(
                                  "Przekazano LPR"
                                )}
                                onChange={() => {
                                  const newValue = form.values.additionalAssistance.includes(
                                    "Przekazano LPR"
                                  )
                                    ? form.values.additionalAssistance.filter(
                                        (item) => item !== "Przekazano LPR"
                                      )
                                    : [
                                        ...form.values.additionalAssistance,
                                        "Przekazano LPR",
                                      ];
                                  form.setFieldValue(
                                    "additionalAssistance",
                                    newValue
                                  );
                                }}
                              />
                              <CustomCheckbox
                                key="Brak pacjenta na miejscu zdarzenia"
                                label="Brak pacjenta na miejscu zdarzenia"
                                isChecked={form.values.additionalAssistance.includes(
                                  "Brak pacjenta na miejscu zdarzenia"
                                )}
                                onChange={() => {
                                  const newValue = form.values.additionalAssistance.includes(
                                    "Brak pacjenta na miejscu zdarzenia"
                                  )
                                    ? form.values.additionalAssistance.filter(
                                        (item) =>
                                          item !==
                                          "Brak pacjenta na miejscu zdarzenia"
                                      )
                                    : [
                                        ...form.values.additionalAssistance,
                                        "Brak pacjenta na miejscu zdarzenia",
                                      ];
                                  form.setFieldValue(
                                    "additionalAssistance",
                                    newValue
                                  );
                                }}
                              />
                              <CustomCheckbox
                                key="Pacjent nie wyraża zgody na udzielenie pomocy"
                                label="Pacjent nie wyraża zgody na udzielenie pomocy"
                                isChecked={form.values.additionalAssistance.includes(
                                  "Pacjent nie wyraża zgody na udzielenie pomocy"
                                )}
                                onChange={() => {
                                  const newValue = form.values.additionalAssistance.includes(
                                    "Pacjent nie wyraża zgody na udzielenie pomocy"
                                  )
                                    ? form.values.additionalAssistance.filter(
                                        (item) =>
                                          item !==
                                          "Pacjent nie wyraża zgody na udzielenie pomocy"
                                      )
                                    : [
                                        ...form.values.additionalAssistance,
                                        "Pacjent nie wyraża zgody na udzielenie pomocy",
                                      ];
                                  form.setFieldValue(
                                    "additionalAssistance",
                                    newValue
                                  );
                                }}
                              />
                            </Flex>
                            {form.values.additionalAssistance.includes(
                              "Udzielono pomocy i przewieziono do:"
                            ) && (
                              <Flex direction={"column"}>
                                <CustomCheckbox
                                  key="IP/SOR"
                                  label="IP/SOR"
                                  isChecked={
                                    form.values.transportDestination ===
                                    "IP/SOR"
                                  }
                                  onChange={() => {
                                    form.setFieldValue(
                                      "transportDestination",
                                      "IP/SOR"
                                    );
                                  }}
                                />
                                <CustomCheckbox
                                  key="Centrum urazowe"
                                  label="Centrum urazowe"
                                  isChecked={
                                    form.values.transportDestination ===
                                    "Centrum urazowe"
                                  }
                                  onChange={() => {
                                    form.setFieldValue(
                                      "transportDestination",
                                      "Centrum urazowe"
                                    );
                                  }}
                                />
                                <CustomCheckbox
                                  key="Inne"
                                  label="Inne"
                                  isChecked={
                                    form.values.transportDestination === "Inne"
                                  }
                                  onChange={() => {
                                    form.setFieldValue(
                                      "transportDestination",
                                      "Inne"
                                    );
                                  }}
                                />
                                <CustomCheckbox
                                  key="Jednostki wyspecjalizowanej szpitala"
                                  label="Jednostki wyspecjalizowanej szpitala"
                                  isChecked={
                                    form.values.transportDestination ===
                                    "Jednostki wyspecjalizowanej szpitala"
                                  }
                                  onChange={() => {
                                    form.setFieldValue(
                                      "transportDestination",
                                      "Jednostki wyspecjalizowanej szpitala"
                                    );
                                  }}
                                />
                              </Flex>
                            )}
                            {form.values.additionalAssistance.includes(
                              "Pacjent nie wyraża zgody na udzielenie pomocy"
                            ) && (
                              <Flex direction={"row"} gap={3}>
                                <Flex direction={"column"}>
                                  <CustomCheckbox
                                    key="udzielenie pomocy medycznej"
                                    label="udzielenie pomocy medycznej"
                                    isChecked={
                                      form.values.refusalReason ===
                                      "udzielenie pomocy medycznej"
                                    }
                                    onChange={() => {
                                      form.setFieldValue(
                                        "refusalReason",
                                        "udzielenie pomocy medycznej"
                                      );
                                    }}
                                  />
                                  <CustomCheckbox
                                    key="przewiezienie do szpitala"
                                    label="przewiezienie do szpitala"
                                    isChecked={
                                      form.values.refusalReason ===
                                      "przewiezienie do szpitala"
                                    }
                                    onChange={() => {
                                      form.setFieldValue(
                                        "refusalReason",
                                        "przewiezienie do szpitala"
                                      );
                                    }}
                                  />
                                </Flex>
                                <Field name="refusalDateTime">
                                  {({ field }) => (
                                    <Flex direction={"column"}>
                                      <FormLabel fontWeight={"bold"}>
                                        Data i godzina odmowy
                                      </FormLabel>
                                      <Input
                                        {...field}
                                        type="datetime-local"
                                        placeholder="Data i godzina"
                                      />
                                    </Flex>
                                  )}
                                </Field>
                              </Flex>
                            )}
                          </Flex>
                          <FormErrorMessage>
                            {form.errors.assistanceProvided}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                  </SimpleGrid>
                  <Text fontSize="xl">IV - Zgon</Text>
                  <SimpleGrid columns={{ sm: 1, md: 4, xl: 5 }} spacing="24px">
                    <Field name="deathOccurred">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors.deathOccurred &&
                            form.touched.deathOccurred
                          }
                        >
                          <FormLabel fontWeight={"bold"}>Zgon nastąpił</FormLabel>
                          <ReactSelect
                            {...field}
                            options={[
                              {
                                label: "Przed przybyciem",
                                value: "Przed przybyciem",
                              },
                              {
                                label: "W trakcie MCR",
                                value: "W trakcie MCR",
                              },
                              {
                                label: "W trakcie transportu",
                                value: "W trakcie transportu",
                              },
                            ]}
                            styles={darkStyles()}
                            placeholder="Wybierz..."
                            onChange={(selectedOption) =>
                              form.setFieldValue(field.name, selectedOption)
                            }
                          />
                          <FormErrorMessage>
                            {form.errors.deathOccurred}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Field name="deathTime">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors.deathTime && form.touched.deathTime
                          }
                        >
                          <FormLabel fontWeight={"bold"}>
                            Czas stwierdzenia zgonu/odstąpienia
                          </FormLabel>
                          <Input type="time" {...field} />
                          <FormErrorMessage>
                            {form.errors.deathTime}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Field name="crimeSuspected">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors.crimeSuspected &&
                            form.touched.crimeSuspected
                          }
                        >
                          <FormLabel fontWeight={"bold"}>
                            Podejrzenie popełnienia przestępstwa
                          </FormLabel>
                          <Flex gap={3}>
                            <CustomCheckbox
                              key="TAK"
                              label="TAK"
                              isChecked={form.values.crimeSuspected === "TAK"}
                              onChange={() => {
                                form.setFieldValue(field.name, "TAK");
                              }}
                            />
                            <CustomCheckbox
                              key="NIE"
                              label="NIE"
                              isChecked={form.values.crimeSuspected === "NIE"}
                              onChange={() => {
                                form.setFieldValue(field.name, "NIE");
                              }}
                            />
                          </Flex>
                          <FormErrorMessage>
                            {form.errors.crimeSuspected}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Field name="notified">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors.notified && form.touched.notified
                          }
                        >
                          <FormLabel fontWeight={"bold"}>
                            Powiadomiono
                            <Text fontSize="xs">
                              (Jeżeli inne, wpisz ręcznie)
                            </Text>
                          </FormLabel>
                          <Creatable
                            {...field}
                            options={[{ label: "Policja", value: "Policja" }]}
                            formatCreateLabel={(inputValue) =>
                              `Utwórz: "${inputValue}"`
                            }
                            styles={darkStyles()}
                            placeholder="Wybierz..."
                            onChange={(selectedOption) =>
                              form.setFieldValue(field.name, selectedOption)
                            }
                          />
                          <FormErrorMessage>
                            {form.errors.notified}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Field name="deathCardIssued">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors.deathCardIssued &&
                            form.touched.deathCardIssued
                          }
                        >
                          <FormLabel fontWeight={"bold"}>Wydano kartę zgonu</FormLabel>
                          <Flex gap={3}>
                            <CustomCheckbox
                              key="TAK"
                              label="TAK"
                              isChecked={form.values[field.name] === "TAK"}
                              onChange={() => {
                                form.setFieldValue(field.name, "TAK");
                              }}
                            />
                            <CustomCheckbox
                              key="NIE"
                              label="NIE"
                              isChecked={form.values[field.name] === "NIE"}
                              onChange={() => {
                                form.setFieldValue(field.name, "NIE");
                              }}
                            />
                          </Flex>
                          <FormErrorMessage>
                            {form.errors.deathCardIssued}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                  </SimpleGrid>
                  <Text fontSize="xl">V - Podsumowanie</Text>
                  <SimpleGrid columns={{ sm: 1, md: 4 }} spacing="24px">
                    <Field name="medicalCardIssued">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors.medicalCardIssued &&
                            form.touched.medicalCardIssued
                          }
                        >
                          <FormLabel fontWeight={"bold"}>
                            Wydano kartę medycznych czynności ratunkowych
                            <Text fontSize="xs">
                              (Jeżeli inne, wpisz ręcznie)
                            </Text>
                          </FormLabel>
                          <Creatable
                            {...field}
                            options={[
                              { label: "Pacjent", value: "Pacjent" },
                              {
                                label: "Przedstawiciel ustawowy",
                                value: "Przedstawiciel ustawowy",
                              },
                              { label: "Szpital", value: "Szpital" },
                            ]}
                            placeholder="Wybierz..."
                            styles={darkStyles()}
                            formatCreateLabel={(inputValue) =>
                              `Utwórz: "${inputValue}"`
                            }
                            onChange={(selectedOption) =>
                              form.setFieldValue(field.name, selectedOption)
                            }
                          />
                          <FormErrorMessage>
                            {form.errors.medicalCardIssued}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                    <Field name="signature">
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            form.errors.signature && form.touched.signature
                          }
                        >
                          <FormLabel fontWeight={"bold"}>Podpis</FormLabel>
                          <SignatureCanvas
                            penColor="black"
                            canvasProps={{
                              width: 300,
                              height: 100,
                              className: "sigCanvas",
                            }}
                            ref={(ref) => {
                              if (ref) {
                                ref.onEnd = () => {
                                  form.setFieldValue(
                                    field.name,
                                    ref.toDataURL()
                                  );
                                };
                              }
                            }}
                          />
                          <FormErrorMessage>
                            {form.errors.signature}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                    </Field>
                  </SimpleGrid>
                  <Button
                    mt={4}
                    colorScheme="red"
                    isLoading={isSubmitting}
                    type="submit"
                  >
                    Wyślij
                  </Button>
                </Flex>
              </Form>
            )}
          </Formik>
        </Flex>
      </Card>
    </Flex>
  );
};

export default KZWForm;
